import { Helmet } from 'react-helmet-async';
import NonBrandClusterManager from 'src/sections/cluster-manager/nonbrand-cluster-manager';

export default function NonBrandedSearchPerformanceClusterManager() {
  return (
    <>
      <Helmet>
        <title>Cluster Manager</title>
      </Helmet>

      <NonBrandClusterManager />
    </>
  );
}
